var _path, _path2, _path3, _circle, _circle2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2051 10.7583L22.2909 5.83036C22.3721 5.46212 22.1393 5.09748 21.771 5.01671C21.4028 4.93457 21.0386 5.16788 20.9578 5.53613L19.9898 9.92843H15.6363C15.2595 9.92843 14.954 10.234 14.954 10.6112C14.954 10.9885 15.2595 11.294 15.6363 11.294H15.8949L14.4246 14.7747C14.278 15.1227 14.44 15.5225 14.7879 15.6692C14.8737 15.7057 14.9648 15.7233 15.0533 15.7233C15.3195 15.7233 15.5723 15.5663 15.6824 15.3059L17.0245 12.1298L19.1532 12.1302L20.4939 15.3059C20.6415 15.6534 21.0422 15.8145 21.3883 15.6692C21.7358 15.5225 21.8983 15.1222 21.7516 14.7747L20.2818 11.294H20.5404C20.859 11.2936 21.1352 11.0715 21.2051 10.7583Z",
    fill: "#240b3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41168 11.2934H8.67026C9.04708 11.2934 9.3526 10.9879 9.3526 10.6107C9.3526 10.2334 9.04708 9.92788 8.67026 9.92788H4.31677L3.34922 5.53602C3.26754 5.16778 2.90246 4.93401 2.53602 5.0166C2.16823 5.09738 1.93491 5.46201 2.01614 5.83026L3.10192 10.7582C3.17097 11.071 3.44805 11.2939 3.76846 11.2939H4.02705L2.55678 14.7755C2.41011 15.123 2.57257 15.5224 2.92006 15.6691C3.26664 15.8153 3.66738 15.6528 3.81449 15.3058L5.15525 12.1301L7.28393 12.1297L8.62514 15.3058C8.73525 15.5662 8.98797 15.7232 9.25422 15.7232C9.34267 15.7232 9.43293 15.7056 9.51957 15.6691C9.86706 15.5224 10.0295 15.1221 9.88285 14.7755L8.41168 11.2934Z",
    fill: "#240b3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2195 14.3573H12.835V8.47035H16.5039C16.8807 8.47035 17.1867 8.16483 17.1867 7.78801C17.1867 7.41119 16.8807 7.10522 16.5039 7.10522H7.80144C7.42462 7.10522 7.11865 7.41119 7.11865 7.78801C7.11865 8.16438 7.42462 8.47035 7.80144 8.47035H11.4703V14.3573H11.0859C10.709 14.3573 10.4035 14.6637 10.4035 15.0405C10.4035 15.4173 10.709 15.7233 11.0859 15.7233H13.2195C13.5972 15.7233 13.9027 15.4173 13.9027 15.0405C13.9027 14.6637 13.5972 14.3573 13.2195 14.3573Z",
    fill: "#240b3b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84552,
    cy: 17.7603,
    r: 0.75,
    stroke: "#240b3b",
    strokeWidth: 0.961539
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0765,
    cy: 17.7603,
    r: 0.75,
    stroke: "#240b3b",
    strokeWidth: 0.961539
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.46094,
    y: 17.145,
    width: 16,
    height: 1.23077,
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup);
export default __webpack_public_path__ + "static/media/popup.3125d0cd0377da5cccfa1e99a1fe8a24.svg";
export { ForwardRef as ReactComponent };